import { CloudDiscoveryKey } from '../../utils/contexts';
import ActiveExecutions from '../Orchestrator/ActiveExecutions';
import Dashboard from '../Orchestrator/Dashboard';
import ExecutorPoolDetail from '../Orchestrator/ExecutorPoolDetail';
import ExecutorPools from '../Orchestrator/ExecutorPools';
import RunnableDetail from '../Orchestrator/RunnableDetail';
import Runnables from '../Orchestrator/Runnables';
import WorkflowDetail from '../Orchestrator/WorkflowDetail';
import Workflows from '../Orchestrator/Workflows';
import { RoutePaths } from '../RoutePaths';
import type { RouteDefinition } from './routeDefinitions';

const sharedParams: Partial<RouteDefinition> = {
  exact: true,
  requiresAuth: true,
  requiresWorkspaces: true,
  requiresDiscoveryKey: CloudDiscoveryKey.orchestratorApiUrl,
};

export const ORCHESTRATOR_ROUTE_DEFINITIONS: RouteDefinition[] = [
  {
    ...sharedParams,
    path: RoutePaths.ORCHESTRATOR_ENTRY,
    render: () => <Dashboard />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ORCHESTRATOR,
    render: () => <Dashboard />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ORCHESTRATOR_WORKFLOWS,
    requiresPermission: ({ orchestrator }) => !!orchestrator?.canViewWorkflows,
    render: () => <Workflows />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ORCHESTRATOR_WORKFLOW_DETAIL,
    render: () => <WorkflowDetail />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ORCHESTRATOR_RUNNABLES,
    requiresPermission: ({ orchestrator }) => !!orchestrator?.canViewRunnables,
    render: () => <Runnables />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ORCHESTRATOR_EXECUTOR_POOLS,
    requiresPermission: ({ orchestrator }) => !!orchestrator?.canViewRunnables,
    render: () => <ExecutorPools />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ORCHESTRATOR_EXECUTOR_POOL_DETAIL,
    render: () => <ExecutorPoolDetail />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ORCHESTRATOR_RUNNABLE_DETAIL,
    render: () => <RunnableDetail />,
  },
  {
    ...sharedParams,
    path: RoutePaths.ORCHESTRATOR_ACTIVE_EXECUTIONS,
    requiresPermission: ({ orchestrator }) => !!orchestrator?.canViewWorkflows,
    render: () => <ActiveExecutions />,
  },
];
